import { render, staticRenderFns } from "./ModalPromptFavoritos.vue?vue&type=template&id=787aa4a1&scoped=true"
import script from "./ModalPromptFavoritos.vue?vue&type=script&lang=js"
export * from "./ModalPromptFavoritos.vue?vue&type=script&lang=js"
import style0 from "./ModalPromptFavoritos.vue?vue&type=style&index=0&id=787aa4a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787aa4a1",
  null
  
)

export default component.exports